import React from 'react';

export const ClickDMIcon: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'>
    <path
      fill='var(--text-high-emphasis)'
      fillRule='evenodd'
      d='M6.553 3l4.777 5-4.777 5a1.202 1.202 0 000 1.656 1.093 1.093 0 001.592 0l5.525-5.777c.232-.241.344-.56.329-.879a1.185 1.185 0 00-.33-.879L8.146 1.344a1.093 1.093 0 00-1.592 0 1.202 1.202 0 000 1.656z'
      clipRule='evenodd'
    ></path>
  </svg>
);
